import { useState } from "react";

const locUser = JSON.parse(localStorage.getItem("user")) || {};

const useData = () => {
  const [user, setUser] = useState({
    isLoggedIn: locUser.isLoggedIn || false,
    email: locUser.email || "",
    password: locUser.password || "",
  });
  const [selectedItems, setSelectedItems] = useState([]);

  const userLogin = (payload) => {
    const updateUser = { ...payload, isLoggedIn: true };
    localStorage.setItem("user", JSON.stringify(updateUser));
    setUser(updateUser);
  };

  const userLogout = () => {
    localStorage.removeItem("user");
    setUser({
      isLoggedIn: false,
      email: "",
      password: "",
    });
  };

  const addSelectedItem = (payload) => {
    if (payload.price <= 0) {
      const updatedItems = selectedItems.filter(
        (item) => item.name !== payload.name
      );
      setSelectedItems(updatedItems);
    } else {
      const isSelected = selectedItems.some(
        (item) => item.name === payload.name
      );
      if (isSelected) {
        const updatedItems = selectedItems.map((item) =>
          item.name === payload.name ? { ...item, ...payload } : item
        );
        setSelectedItems(updatedItems);
      } else {
        setSelectedItems([...selectedItems, payload]);
      }
    }
  };

  const findSelectedItem = (id) => {
    const item = selectedItems.find((item) => item.id === id);
    return item || {};
  };

  const deleteSelectedItem = (id) => {
    const updatedItems = selectedItems.filter((item) => item.id !== id);
    setSelectedItems(updatedItems);
  };

  const emptySelectedItems = () => {
    setSelectedItems([]);
  };

  return {
    user,
    userLogin,
    userLogout,
    selectedItems,
    addSelectedItem,
    findSelectedItem,
    deleteSelectedItem,
    emptySelectedItems,
  };
};

export default useData;
